import chefImg1 from "../../assets/images/best-chef/chef.png";
import chefImg2 from "../../assets/images/best-chef/chef.png";
import chefImg3 from "../../assets/images/best-chef/chef.png";
import chefImg4 from "../../assets/images/best-chef/chef.png";
import chefImg5 from "../../assets/images/best-chef/chef.png";
import chefImg6 from "../../assets/images/best-chef/chef.png";

export const chefsData = [
  {
    img: chefImg1,
    name: "N. Katshi",
    position: "Head Chef",
    details: [
      "Sed luctus massa purus, sed dapibus ex condimentum sed.",
      "Vivamus nulla nibh, dictum nec urna et, tristique elementum mi.",
    ],
    skills: [
      { name: "Behaviour", percentage: 100 },
      { name: "Passionate", percentage: 90 },
      { name: "Motive", percentage: 90 },
    ],
  },
  {
    img: chefImg2,
    name: "B. Brandon",
    position: "Sous Chef",
    details: [
      "Sed luctus massa purus, sed dapibus ex condimentum sed.",
      "Vivamus nulla nibh, dictum nec urna et, tristique elementum mi.",
      "Vivamus nulla nibh, dictum nec urna et, tristique elementum mi.",
    ],
    skills: [
      { name: "Behaviour", percentage: 82 },
      { name: "Passionate", percentage: 99 },
      { name: "Motive", percentage: 90 },
    ],
  },
  {
    img: chefImg3,
    name: "C. Charlson",
    position: "Pastry Chef",
    details: [
      "Sed luctus massa purus, sed dapibus ex condimentum sed.",
      "Vivamus nulla nibh, dictum nec urna et, tristique elementum mi.",
    ],
    skills: [
      { name: "Behaviour", percentage: 92 },
      { name: "Passionate", percentage: 60 },
      { name: "Motive", percentage: 80 },
    ],
  },
  {
    img: chefImg4,
    name: "D. Davidson",
    position: "Grill Chef",
    details: [
      "Sed luctus massa purus, sed dapibus ex condimentum sed.Vestibulum eget imperdiet metus, varius facilisis nisl.Integer et sem eros. Pellentesque ullamcorper imperdietlaoreet",
      "Sed luctus massa purus, sed dapibus ex condimentum sed.",
      "Vivamus nulla nibh, dictum nec urna et, tristique elementum mi.",
    ],
    skills: [
      { name: "Behaviour", percentage: 82 },
      { name: "Passionate", percentage: 90 },
      { name: "Motive", percentage: 60 },
    ],
  },
  {
    img: chefImg5,
    name: "E. Edison",
    position: "Sauce Chef",
    details: [
      "Sed luctus massa purus, sed dapibus ex condimentum sed.",
      "Vivamus nulla nibh, dictum nec urna et, tristique elementum mi.",
      "Vivamus nulla nibh, dictum nec urna et, tristique elementummi. Aenean suscipit sem nec neque pharetra, sed pretium leofeugiat. Etiam magna nunc, varius sit amet eleifend sit amet,lobortis nec nulla",
    ],
    skills: [
      { name: "Behaviour", percentage: 82 },
      { name: "Passionate", percentage: 50 },
      { name: "Motive", percentage: 80 },
    ],
  },
  {
    img: chefImg6,
    name: "F. Fordson",
    position: "Fish Chef",
    details: [
      "Vivamus nulla nibh, dictum nec urna et, tristique elementummi. Aenean suscipit sem nec neque pharetra, sed pretium leofeugiat. Etiam magna nunc, varius sit amet eleifend sit amet,lobortis nec nulla",
      "Sed luctus massa purus, sed dapibus ex condimentum sed.",
      "Vivamus nulla nibh, dictum nec urna et, tristique elementum mi.",
    ],
    skills: [
      { name: "Behaviour", percentage: 92 },
      { name: "Passionate", percentage: 86 },
      { name: "Motive", percentage: 98 },
    ],
  },
];
